import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface IuseStickyNav {
    isSticky: boolean
    setIsSticky: (isSticky: boolean) => void
    selectedElement: string | 'none'
    setSelectedElement: (el: string) => void
    space: string
}

export const useStickyNav = create<IuseStickyNav>()(
    devtools(
        (set, get) => ({
            space: 'scroll-mt-[180px]',
            isSticky: false,
            setIsSticky: (isSticky) => set({ isSticky }),
            selectedElement: 'none',
            setSelectedElement: (selectedElement) => set({ selectedElement }),
        }),
        { name: `useStickyNav` }
    )
)
